import React from "react";
import ChatMessage, {
  ChatContainer,
} from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import Gutter from "../../../../ui-kit/Gutter";
import { useWebTranslation } from "../../../../translations";
import { updateAnimalById } from "components/Signup/store/slices/animals";
import { useDispatch } from "react-redux";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { StepProps } from "../types";
import { Access } from "components/Signup/store/state/types";

const AnimalAccess = ({ next, transitioning }: StepProps) => {
  const { t } = useWebTranslation();
  const dispatch = useDispatch();
  const { access, name, id } = useCurrentAnimal();

  const accesses: {
    label: string;
    value: Access;
  }[] = [
    {
      label: t("signup.animal_access.option.outdoor"),
      value: "outdoor",
    },
    {
      label: t("signup.animal_access.option.indoor"),
      value: "indoor",
    },
  ];

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>
          {t("signup.animal_access.text", {
            name: name ?? "",
          })}
        </Typography>
      </ChatMessage>
      <ChatMessage>
        <Typography>{t("signup.animal_access.text2")}</Typography>
      </ChatMessage>
      <Gutter size={2} />
      {accesses.map((item) => (
        <ChatMessage
          component="button"
          fromMe
          onPress={() => {
            dispatch(updateAnimalById({ id, update: { access: item.value } }));
            next();
          }}
          blink
          key={item.value}
          active={access === item.value}
        >
          <Typography>{item.label}</Typography>
        </ChatMessage>
      ))}
    </ChatContainer>
  );
};

export default AnimalAccess;
